import React from 'react';
import { t } from '../../../../../../modules/infra/i18n';

const Header = ({ duplicates, duplicateCellClass }) => (
  <div className="c-table-card__head c-table-card__head--underline">
    <div className="c-table-card__cell u-2/12">
      <div className="c-label">{t('customers:duplicates.customer_details_header')}</div>
    </div>
    <div className="c-table-card__cell u-3/12">
      <div className="c-label">{t('customers:duplicates.surviving_records_header')}</div>
    </div>
    {
      duplicates.map((_, idx) => (
        <div className={duplicateCellClass}>
          <div className="c-label">{t('customers:duplicates.record_number', { number: idx + 1 })}</div>
        </div>
      ))
    }
  </div>
);

export default Header;
